/**
 * AdminV2Referrals — wraps the existing AdminReferrals component within the V2 layout.
 * The referral admin page has heavy custom logic (revoke/adjust/link modals, leaderboard).
 * We keep the V1 component untouched — CSS overrides via .pv2-legacy-skin flip the
 * Tailwind colors to V2 dark editorial palette.
 */
import React from 'react';
import PortalV2Layout from './PortalV2Layout';
import AdminReferrals from '../portal/AdminReferrals';

const AdminV2Referrals = () => (
  <PortalV2Layout
    eyebrow="Growth"
    title="Referrals"
    subtitle="Track referral credits, payouts, and link clients across systems."
    crumbs={<><span style={{ opacity: 0.5 }}>Admin /</span> <strong style={{ marginLeft: 6 }}>Referrals</strong></>}
  >
    <div className="pv2-legacy-skin" style={{ background: 'var(--pv2-ink)', border: '1px solid var(--pv2-ink-line)', padding: 24 }} data-testid="pv2-referrals-wrap">
      <AdminReferrals embedded />
    </div>
  </PortalV2Layout>
);

export default AdminV2Referrals;
